import { StringBool } from '../enums/booleans';

export function toStringBool(value: boolean): StringBool {
  return value ? StringBool.True : StringBool.False;
}
